define('cart_promocode_notifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_notifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " \n";
},"useData":true}, 'extensions/Gofer Parts/Gofer_Parts_2025_1_Summit/1.0.4/', 'extensions/Gofer Parts/Gofer_Parts_2025_1_Summit/1.0.4/', Handlebars);
});